import { createUseStyles } from 'react-jss'

export const styles = {
  toggle: {
    marginLeft: '5px',
    marginRight: '15px',
    padding: 0,
    width: '26px',
    height: '26px',
    fontSize: '16px',
    textAlign: 'center'
  }
}

export const useStyles = createUseStyles(styles)
